<template>
  <sweet-modal ref="heat-map" :title="$t('ct-heat-map-title')" hide-close-button blocking>
    <template v-if="!loading">
      <slot name="content">
        <p>{{$t('ct-heat-map-desc')}}</p>
        <template v-if="heat_map">

          <div class="form-group form-check">
            <div class="custom-control custom-switch form-group w-100">
              <input type="checkbox" class="custom-control-input" id="hm-enable-site" v-model="heat_map.enabled">
              <label class="custom-control-label" for="hm-enable-site">{{$t('ct-heat-map-enable-site')}}</label>
            </div>
            <small>{{$t('ct-heat-map-enable-site-desc')}}</small>
          </div>

        </template>
      </slot>
    </template>
    <div class="text-center" v-else>
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <button v-if="action === 'edit'" @click.prevent="goToHeatMap" target="_blank" slot="button"
            class="btn btn-primary float-left m-0"><i class="svg-icon svgi-social-proof svgi-gray-light"/>{{ $t('ct-goto-heat-map')}}</button>

    <button slot="button" class="btn btn-outline-light" @click.prevent="close()">{{ $t('ct-close')}}</button>

    <button slot="button" class="btn btn-success" @click.prevent="save"><i class="svg-icon svgi-save"></i>{{ ( action === 'create' ? $t('ct-enable') : $t('ct-save'))}}</button>

  </sweet-modal>
</template>

<script>
import {SweetModal} from "sweet-modal-vue";
import {getWebsiteConfig, setWebsiteConfig} from "../../../../js/services/editor/configManager";
import {createHeatMap, hasWithURL, checkHeatMap} from '../../../../js/services/integrations-internas/heatMap';
import {mapGetters} from 'vuex';

export default {
  name: 'HeatMap',
  props: ['website_id', 'website'],

  components: {
    SweetModal
  },

  data() {
    return {
      loading: false,
      action: 'create',
      website_configs: false,
      heat_map: false,
      exist: 0,
    }
  },

  methods: {
    ...mapGetters({getUser: 'user'}),

    async open() {
      this.$refs['heat-map'].open();

      this.$loading.show();
      this.loading = true;

      await this.getWebsiteConfigs();
      this.loading = false;
      this.$loading.hide();
    },

    close() {
      this.$refs['heat-map'].close();
    },

    async checkHeatMap(heatMapSettings) {
      this.$loading.show();

      await checkHeatMap({project_id: heatMapSettings.project_id})
        .then(({data}) => {
          if (!data.data.result) {
            this.heat_map = false;
            var obj = {
              website_id: this.website_id,
              key: 'heatMapSettings',
              value: JSON.stringify({
                ...heatMapSettings,
                'enabled': false
              })
            };

            this.setWebsiteSettings(obj);
          }else
            this.action = 'edit';
            this.heat_map = heatMapSettings;

            if(data.data.url !== this.getUrl())
              this.updateURL();

        });

      this.$loading.hide();
    },

    async getWebsiteConfigs() {
      await getWebsiteConfig(this.website_id)
        .then(async ({data}) =>  {
          this.website_configs = data;
          if (Object.keys(data).includes('heatMapSettings')) {
            let heatMapSettings = JSON.parse(this.website_configs['heatMapSettings'].value);
            if(Object.keys(heatMapSettings).length > 0) {
              await this.checkHeatMap(heatMapSettings);
            }
          }

        })
        .catch(error => {
          console.error('error', error);
        });
    },

    updateURL() {
      const { id, title} = this.website

      let data = {
        site_uniq_id: id,
        site_name: title,
        site_url: this.getUrl()
      }

      updateURL(data)
        .then(({data}) => {

        })
    },

    async setWebsiteSettings(obj){

      this.$loading.show()
      await setWebsiteConfig(obj)
        .then(() => {

          this.heat_map = JSON.parse(obj.value);
        })
        .catch((error) => console.error('error save website-config', error))
        .finally(() => {
          if (this.action === 'edit') {
            this.$refs['heat-map'].close();
          }

          if(this.action === 'create')
            this.action= 'edit';
        })

      this.$loading.hide();
    },

    save(){

      if( this.action === 'create'){

        const { id, title} = this.website

        let data = {
          site_uniq_id: id,
          site_name: title,
          site_url: this.getUrl()
        }

        createHeatMap(data)
          .then( ({data}) => {

            if(data['data'].result) {
              var obj = {
                website_id: this.website_id,
                key: 'heatMapSettings',
                value: JSON.stringify({
                  'project_id': data['data']['project_id'],
                  'embed_code': data['data']['embed_code'],
                  'enabled': true
                })
              };

              this.setWebsiteSettings(obj);
            }
          });
      }else{

        var obj = {
          website_id: this.website_id,
          key: 'heatMapSettings',
          value: JSON.stringify(this.heat_map)
        }

        this.setWebsiteSettings(obj);
      }
    },

    getUrl() {
      let user = this.getUser();

      if (typeof this.website.url !== null) {
        if (
          typeof this.website.dominio !== null &&
          this.website.dominio !== '' &&
          this.website.dominio !== null
        ) {
          return 'https://' + this.website.dominio;
        } else {
          if (user.user_editor) {
            let subdominio    = user.user_editor.subdominio.replace('_', '-');
            let premiunDomain = typeof process.env.PREMIUN_DOMAIN !== 'undefined' ? process.env.PREMIUN_DOMAIN : '.site.builderallsite.com';
            let freeDomain    = typeof process.env.FREE_DOMAIN !== 'undefined' ? process.env.FREE_DOMAIN : '.free.builderallsite.com';

            return 'https://' + subdominio + '-' + this.website.url + (user.is_free === '1' ? freeDomain : premiunDomain);
          }
        }
      }
    },

    goToHeatMap(){

      if (
        this.heat_map|| this.heat_map.enabled
      ) {
        var project_id = this.heat_map['project_id'];

        var language = (navigator.language || navigator.userLanguage);
        var hm_url = 'https://clickmap.builderall.com/api/showclickmap.php';

        var params = {
          user_email: this.getUser().email,
          password_md5: this.getUser().user_editor.hash_md5,
          project_id: project_id,
          lang: language.substr(0, 2),
        };

        this.postAndRedirect(hm_url, params);
      } else {
        this.$snotify.error(this.$t('ct-browser-not-exist'), {
          position: 'centerTop'
        });
      }
    },

    postAndRedirect(url, params, method = 'POST') {
      const form = document.createElement('form');
      form.method = method;
      form.action = url;
      form.target = '_blank';
      form.id = 'form-hm';


      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = params[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/HeatMap.vue